import { Link, useSearchParams } from 'react-router-dom';
import { useEffect, useMemo } from 'react';
import {
  ArrowLeft,
  ArrowRight,
  Camera,
  CircleDot,
  Filter,
  HardDrive,
  Moon,
  Move3d,
  PanelsTopLeft,
  RotateCcw,
  ScanEye,
  SlidersHorizontal,
} from 'lucide-react';

import './SecurityCameraLineup.css';

const PRODUCTS = [
  {
    "id": "hs-d4f-001",
    "hsModel": "HS-D4F-001",
    "name": "4MP デュアルライト PoEドームカメラ（固定焦点）",
    "categoryLabel": "ドーム",
    "type": "dome",
    "resolution": "4MP",
    "resolutionKey": "4MP",
    "lens": "2.8mm F1.0 fixed",
    "lensType": "fixed",
    "image": "/images/security-camera/products/hs-d4f-001.png",
    "features": [
      "night"
    ],
    "locations": [
      "shop",
      "office",
      "warehouse"
    ],
    "tags": [
      "4MP",
      "PoE",
      "固定焦点",
      "デュアルライト"
    ],
    "description": "店舗・事務所・施設内などの標準監視に使いやすい、固定焦点タイプのPoEドームカメラです。",
    "status": "standard"
  },
  {
    "id": "hs-d5f-001",
    "hsModel": "HS-D5F-001",
    "name": "5MP デュアルライト PoEドームカメラ（固定焦点）",
    "categoryLabel": "ドーム",
    "type": "dome",
    "resolution": "5MP",
    "resolutionKey": "5MP",
    "lens": "2.8mm F1.0 fixed",
    "lensType": "fixed",
    "image": "/images/security-camera/products/hs-d5f-001.png",
    "features": [
      "night"
    ],
    "locations": [
      "shop",
      "office",
      "warehouse"
    ],
    "tags": [
      "5MP",
      "PoE",
      "固定焦点",
      "デュアルライト"
    ],
    "description": "店舗・事務所・施設内などの標準監視に使いやすい、固定焦点タイプのPoEドームカメラです。",
    "status": "standard"
  },
  {
    "id": "hs-d8f-001",
    "hsModel": "HS-D8F-001",
    "name": "8MP（4K）デュアルライト PoEドームカメラ（固定焦点）",
    "categoryLabel": "ドーム",
    "type": "dome",
    "resolution": "8MP",
    "resolutionKey": "8MP",
    "lens": "2.8mm F1.0 fixed",
    "lensType": "fixed",
    "image": "/images/security-camera/products/hs-d8f-001.png",
    "features": [
      "night"
    ],
    "locations": [
      "shop",
      "office",
      "warehouse"
    ],
    "tags": [
      "8MP / 4K",
      "PoE",
      "固定焦点",
      "デュアルライト"
    ],
    "description": "店舗・事務所・施設内などの標準監視に使いやすい、固定焦点タイプのPoEドームカメラです。",
    "status": "standard"
  },
  {
    "id": "hs-d5m-001",
    "hsModel": "HS-D5M-001",
    "name": "5MP 5倍電動ズーム デュアルライト PoEドームカメラ",
    "categoryLabel": "ドーム",
    "type": "dome",
    "resolution": "5MP",
    "resolutionKey": "5MP",
    "lens": "5× 2.7–13.5mm motorized",
    "lensType": "motorized",
    "image": "/images/security-camera/products/hs-d5m-001.png",
    "features": [
      "night"
    ],
    "locations": [
      "shop",
      "office",
      "warehouse"
    ],
    "tags": [
      "5MP",
      "PoE",
      "電動ズーム",
      "デュアルライト"
    ],
    "description": "画角調整が必要な設置場所に対応する、電動ズームタイプのPoEドームカメラです。",
    "status": "standard"
  },
  {
    "id": "hs-d8m-001",
    "hsModel": "HS-D8M-001",
    "name": "8MP（4K）5倍電動ズーム デュアルライト PoEドームカメラ",
    "categoryLabel": "ドーム",
    "type": "dome",
    "resolution": "8MP",
    "resolutionKey": "8MP",
    "lens": "5× 2.7–13.5mm motorized",
    "lensType": "motorized",
    "image": "/images/security-camera/products/hs-d8m-001.png",
    "features": [
      "night"
    ],
    "locations": [
      "shop",
      "office",
      "warehouse"
    ],
    "tags": [
      "8MP / 4K",
      "PoE",
      "電動ズーム",
      "デュアルライト"
    ],
    "description": "画角調整が必要な設置場所に対応する、電動ズームタイプのPoEドームカメラです。",
    "status": "standard"
  },
  {
    "id": "hs-b5f-001",
    "hsModel": "HS-B5F-001",
    "name": "5MP デュアルライト PoEバレットカメラ（固定焦点）",
    "categoryLabel": "バレット",
    "type": "bullet",
    "resolution": "5MP",
    "resolutionKey": "5MP",
    "lens": "2.8mm F1.0 fixed",
    "lensType": "fixed",
    "image": "/images/security-camera/products/hs-b5f-001.png",
    "features": [
      "night"
    ],
    "locations": [
      "parking",
      "warehouse"
    ],
    "tags": [
      "5MP",
      "PoE",
      "固定焦点",
      "デュアルライト"
    ],
    "description": "建物外周・駐車場など、監視方向を明確にしたい場所に適したPoEバレットカメラです。",
    "status": "standard"
  },
  {
    "id": "hs-b8f-001",
    "hsModel": "HS-B8F-001",
    "name": "8MP（4K）デュアルライト PoEバレットカメラ（固定焦点）",
    "categoryLabel": "バレット",
    "type": "bullet",
    "resolution": "8MP",
    "resolutionKey": "8MP",
    "lens": "2.8mm F1.0 fixed",
    "lensType": "fixed",
    "image": "/images/security-camera/products/hs-b8f-001.png",
    "features": [
      "night"
    ],
    "locations": [
      "parking",
      "warehouse"
    ],
    "tags": [
      "8MP / 4K",
      "PoE",
      "固定焦点",
      "デュアルライト"
    ],
    "description": "建物外周・駐車場など、監視方向を明確にしたい場所に適したPoEバレットカメラです。",
    "status": "standard"
  },
  {
    "id": "hs-b5m-001",
    "hsModel": "HS-B5M-001",
    "name": "5MP 5倍電動ズーム デュアルライト PoEバレットカメラ",
    "categoryLabel": "バレット",
    "type": "bullet",
    "resolution": "5MP",
    "resolutionKey": "5MP",
    "lens": "5× 2.7–13.5mm motorized option",
    "lensType": "motorized",
    "image": "/images/security-camera/products/hs-b5m-001.png",
    "features": [
      "night"
    ],
    "locations": [
      "parking",
      "warehouse"
    ],
    "tags": [
      "5MP",
      "PoE",
      "電動ズーム",
      "デュアルライト"
    ],
    "description": "建物外周や駐車場などで画角調整が必要な場合に適した、電動ズームタイプのPoEバレットカメラです。",
    "status": "standard"
  },
  {
    "id": "hs-b8m-001",
    "hsModel": "HS-B8M-001",
    "name": "8MP（4K）5倍電動ズーム デュアルライト PoEバレットカメラ",
    "categoryLabel": "バレット",
    "type": "bullet",
    "resolution": "8MP",
    "resolutionKey": "8MP",
    "lens": "5× 2.7–13.5mm motorized option",
    "lensType": "motorized",
    "image": "/images/security-camera/products/hs-b8m-001.png",
    "features": [
      "night"
    ],
    "locations": [
      "parking",
      "warehouse"
    ],
    "tags": [
      "8MP / 4K",
      "PoE",
      "電動ズーム",
      "デュアルライト"
    ],
    "description": "建物外周や駐車場などで画角調整が必要な場合に適した、電動ズームタイプのPoEバレットカメラです。",
    "status": "standard"
  },
  {
    "id": "hs-t2f-001",
    "hsModel": "HS-T2F-001",
    "name": "2MP IR夜間対応 PoEタレットカメラ（固定焦点）",
    "categoryLabel": "IR夜間対応",
    "type": "night",
    "resolution": "2MP",
    "resolutionKey": "2MP",
    "lens": "2.8mm fixed",
    "lensType": "fixed",
    "image": "/images/security-camera/products/hs-t2f-001.png",
    "features": [
      "night"
    ],
    "locations": [
      "parking",
      "warehouse"
    ],
    "tags": [
      "2MP",
      "PoE",
      "固定焦点",
      "IR夜間対応"
    ],
    "description": "赤外線による夜間監視に対応した、固定焦点タイプのPoEタレットカメラです。",
    "status": "standard"
  },
  {
    "id": "hs-t5f-002",
    "hsModel": "HS-T5F-002",
    "name": "5MP IR夜間対応 PoEタレットカメラ（固定焦点・標準IR）",
    "categoryLabel": "IR夜間対応",
    "type": "night",
    "resolution": "5MP",
    "resolutionKey": "5MP",
    "lens": "2.8mm fixed",
    "lensType": "fixed",
    "image": "/images/security-camera/products/hs-t5f-002.png",
    "features": [
      "night"
    ],
    "locations": [
      "parking",
      "warehouse"
    ],
    "tags": [
      "5MP",
      "PoE",
      "固定焦点",
      "IR夜間対応"
    ],
    "description": "赤外線による夜間監視に対応した、固定焦点タイプのPoEタレットカメラです。",
    "status": "standard"
  },
  {
    "id": "hs-t5f-001",
    "hsModel": "HS-T5F-001",
    "name": "5MP IR夜間対応 PoEタレットカメラ（固定焦点・長距離IR）",
    "categoryLabel": "IR夜間対応",
    "type": "night",
    "resolution": "5MP",
    "resolutionKey": "5MP",
    "lens": "2.8mm fixed",
    "lensType": "fixed",
    "image": "/images/security-camera/products/hs-t5f-001.png",
    "features": [
      "night"
    ],
    "locations": [
      "parking",
      "warehouse"
    ],
    "tags": [
      "5MP",
      "PoE",
      "固定焦点",
      "IR夜間対応"
    ],
    "description": "赤外線による夜間監視に対応した、長距離IRタイプのPoEタレットカメラです。",
    "status": "standard"
  },
  {
    "id": "hs-t8f-002",
    "hsModel": "HS-T8F-002",
    "name": "8MP（4K）IR夜間対応 PoEタレットカメラ（固定焦点・標準IR）",
    "categoryLabel": "IR夜間対応",
    "type": "night",
    "resolution": "8MP",
    "resolutionKey": "8MP",
    "lens": "2.8mm fixed",
    "lensType": "fixed",
    "image": "/images/security-camera/products/hs-t8f-002.png",
    "features": [
      "night"
    ],
    "locations": [
      "parking",
      "warehouse"
    ],
    "tags": [
      "8MP / 4K",
      "PoE",
      "固定焦点",
      "IR夜間対応"
    ],
    "description": "赤外線による夜間監視に対応した、固定焦点タイプのPoEタレットカメラです。",
    "status": "standard"
  },
  {
    "id": "hs-t8f-001",
    "hsModel": "HS-T8F-001",
    "name": "8MP（4K）IR夜間対応 PoEタレットカメラ（固定焦点・長距離IR）",
    "categoryLabel": "IR夜間対応",
    "type": "night",
    "resolution": "8MP",
    "resolutionKey": "8MP",
    "lens": "2.8mm fixed",
    "lensType": "fixed",
    "image": "/images/security-camera/products/hs-t8f-001.png",
    "features": [
      "night"
    ],
    "locations": [
      "parking",
      "warehouse"
    ],
    "tags": [
      "8MP / 4K",
      "PoE",
      "固定焦点",
      "IR夜間対応"
    ],
    "description": "赤外線による夜間監視に対応した、長距離IRタイプのPoEタレットカメラです。",
    "status": "standard"
  },
  {
    "id": "hs-b5m-002",
    "hsModel": "HS-B5M-002",
    "name": "5MP 5倍電動ズーム IR夜間対応 PoEバレットカメラ",
    "categoryLabel": "IR夜間対応",
    "type": "night",
    "resolution": "5MP",
    "resolutionKey": "5MP",
    "lens": "5× 2.7–13.5mm motorized",
    "lensType": "motorized",
    "image": "/images/security-camera/products/hs-b5m-002.png",
    "features": [
      "night"
    ],
    "locations": [
      "parking",
      "warehouse"
    ],
    "tags": [
      "5MP",
      "PoE",
      "電動ズーム",
      "IR夜間対応"
    ],
    "description": "赤外線による夜間監視に対応した、電動ズームタイプのPoEバレットカメラです。",
    "status": "standard"
  },
  {
    "id": "hs-b8m-002",
    "hsModel": "HS-B8M-002",
    "name": "8MP（4K）5倍電動ズーム IR夜間対応 PoEバレットカメラ",
    "categoryLabel": "IR夜間対応",
    "type": "night",
    "resolution": "8MP",
    "resolutionKey": "8MP",
    "lens": "5× 2.7–13.5mm motorized",
    "lensType": "motorized",
    "image": "/images/security-camera/products/hs-b8m-002.png",
    "features": [
      "night"
    ],
    "locations": [
      "parking",
      "warehouse"
    ],
    "tags": [
      "8MP / 4K",
      "PoE",
      "電動ズーム",
      "IR夜間対応"
    ],
    "description": "赤外線による夜間監視に対応した、電動ズームタイプのPoEバレットカメラです。",
    "status": "standard"
  },
  {
    "id": "hs-ptz5-001",
    "hsModel": "HS-PTZ5-001",
    "name": "5MP 5倍光学ズーム PoE PTZカメラ",
    "categoryLabel": "PTZ",
    "type": "ptz",
    "resolution": "5MP",
    "resolutionKey": "5MP",
    "lens": "5× 2.7–13.5mm motorized",
    "lensType": "motorized",
    "image": "/images/security-camera/products/hs-ptz5-001.png",
    "features": [
      "ptz"
    ],
    "locations": [
      "parking",
      "warehouse"
    ],
    "tags": [
      "5MP",
      "PoE",
      "5倍光学ズーム"
    ],
    "description": "カメラの向きとズームを遠隔調整できる、5倍光学ズーム対応のPoE PTZカメラです。",
    "status": "standard"
  },
  {
    "id": "hs-ptz8-001",
    "hsModel": "HS-PTZ8-001",
    "name": "8MP（4K）5倍光学ズーム PoE PTZカメラ",
    "categoryLabel": "PTZ",
    "type": "ptz",
    "resolution": "8MP",
    "resolutionKey": "8MP",
    "lens": "5× 2.7–13.5mm motorized",
    "lensType": "motorized",
    "image": "/images/security-camera/products/hs-ptz8-001.png",
    "features": [
      "ptz"
    ],
    "locations": [
      "parking",
      "warehouse"
    ],
    "tags": [
      "8MP / 4K",
      "PoE",
      "5倍光学ズーム"
    ],
    "description": "カメラの向きとズームを遠隔調整できる、5倍光学ズーム対応のPoE PTZカメラです。",
    "status": "standard"
  },
  {
    "id": "hs-ptz5-002",
    "hsModel": "HS-PTZ5-002",
    "name": "5MP 20倍光学ズーム PoE PTZカメラ",
    "categoryLabel": "PTZ",
    "type": "ptz",
    "resolution": "5MP",
    "resolutionKey": "5MP",
    "lens": "20× 4.7–94mm motorized",
    "lensType": "motorized",
    "image": "/images/security-camera/products/hs-ptz5-002.png",
    "features": [
      "ptz"
    ],
    "locations": [
      "parking",
      "warehouse"
    ],
    "tags": [
      "5MP",
      "PoE",
      "20倍光学ズーム"
    ],
    "description": "広い敷地や離れた対象の確認に向いた、20倍光学ズーム対応のPoE PTZカメラです。",
    "status": "standard"
  },
  {
    "id": "hs-ptz8-002",
    "hsModel": "HS-PTZ8-002",
    "name": "8MP（4K）20倍光学ズーム PoE PTZカメラ",
    "categoryLabel": "PTZ",
    "type": "ptz",
    "resolution": "8MP",
    "resolutionKey": "8MP",
    "lens": "20× 4.7–94mm motorized",
    "lensType": "motorized",
    "image": "/images/security-camera/products/hs-ptz8-002.png",
    "features": [
      "ptz"
    ],
    "locations": [
      "parking",
      "warehouse"
    ],
    "tags": [
      "8MP / 4K",
      "PoE",
      "20倍光学ズーム"
    ],
    "description": "広い敷地や離れた対象の確認に向いた、20倍光学ズーム対応のPoE PTZカメラです。",
    "status": "standard"
  },
  {
    "id": "hs-pan8f-001",
    "hsModel": "HS-PAN8F-001",
    "name": "8MP（4K）180°パノラマ PoEカメラ",
    "categoryLabel": "180°パノラマ",
    "type": "panoramic",
    "resolution": "8MP",
    "resolutionKey": "8MP",
    "lens": "Dual 2.8mm fixed lenses",
    "lensType": "fixed",
    "image": "/images/security-camera/products/hs-pan8f-001.png",
    "features": [
      "panoramic"
    ],
    "locations": [
      "shop",
      "warehouse",
      "parking"
    ],
    "tags": [
      "8MP / 4K",
      "PoE",
      "固定焦点",
      "180°"
    ],
    "description": "広い範囲を一度に確認したい場所に適した、180°パノラマ対応PoEカメラです。",
    "status": "standard"
  },
  {
    "id": "hs-pan8f-002",
    "hsModel": "HS-PAN8F-002",
    "name": "8MP（4K）180°パノラマ PoEカメラ（新製品）",
    "categoryLabel": "180°パノラマ",
    "type": "panoramic",
    "resolution": "8MP",
    "resolutionKey": "8MP",
    "lens": "TBC",
    "lensType": "fixed",
    "image": "/images/security-camera/products/hs-pan8f-002.png",
    "features": [
      "panoramic"
    ],
    "locations": [
      "shop",
      "warehouse",
      "parking"
    ],
    "tags": [
      "8MP / 4K",
      "PoE",
      "固定焦点",
      "180°",
      "詳細仕様確認中"
    ],
    "description": "8MP（4K）180°パノラマの新製品です。詳細仕様は現在サプライヤー確認中です。",
    "status": "tbc"
  },
  {
    "id": "hs-pan4f-001",
    "hsModel": "HS-PAN4F-001",
    "name": "4MP 180°パノラマ PoEバレットカメラ",
    "categoryLabel": "180°パノラマ",
    "type": "panoramic",
    "resolution": "4MP",
    "resolutionKey": "4MP",
    "lens": "3.6mm fixed",
    "lensType": "fixed",
    "image": "/images/security-camera/products/hs-pan4f-001.png",
    "features": [
      "panoramic"
    ],
    "locations": [
      "shop",
      "warehouse",
      "parking"
    ],
    "tags": [
      "4MP",
      "PoE",
      "固定焦点",
      "180°"
    ],
    "description": "広い範囲を一度に確認したい場所に適した、180°パノラマ対応PoEカメラです。",
    "status": "standard"
  },
  {
    "id": "hs-pan8f-003",
    "hsModel": "HS-PAN8F-003",
    "name": "8MP（4K）180°パノラマ PoEバレットカメラ",
    "categoryLabel": "180°パノラマ",
    "type": "panoramic",
    "resolution": "8MP",
    "resolutionKey": "8MP",
    "lens": "2.8mm fixed",
    "lensType": "fixed",
    "image": "/images/security-camera/products/hs-pan8f-003.png",
    "features": [
      "panoramic"
    ],
    "locations": [
      "shop",
      "warehouse",
      "parking"
    ],
    "tags": [
      "8MP / 4K",
      "PoE",
      "固定焦点",
      "180°"
    ],
    "description": "広い範囲を一度に確認したい場所に適した、180°パノラマ対応PoEカメラです。",
    "status": "standard"
  },
  {
    "id": "hs-lpr2m-001",
    "hsModel": "HS-LPR2M-001",
    "name": "2MP 10倍ズーム PoE LPRカメラ",
    "categoryLabel": "LPR",
    "type": "lpr",
    "resolution": "2MP",
    "resolutionKey": "2MP",
    "lens": "10× zoom",
    "lensType": "motorized",
    "image": "/images/security-camera/products/hs-lpr2m-001.png",
    "features": [
      "lpr"
    ],
    "locations": [
      "parking"
    ],
    "tags": [
      "2MP",
      "PoE",
      "ズーム",
      "LPR"
    ],
    "description": "車両出入口などでナンバー確認を行う用途を想定したPoE LPRカメラです。認識仕様・推奨距離は案件ごとに確認します。",
    "status": "standard"
  },
  {
    "id": "hs-lpr4m-001",
    "hsModel": "HS-LPR4M-001",
    "name": "4MP 5倍ズーム PoE LPRカメラ",
    "categoryLabel": "LPR",
    "type": "lpr",
    "resolution": "4MP",
    "resolutionKey": "4MP",
    "lens": "5× zoom",
    "lensType": "motorized",
    "image": "/images/security-camera/products/hs-lpr4m-001.png",
    "features": [
      "lpr"
    ],
    "locations": [
      "parking"
    ],
    "tags": [
      "4MP",
      "PoE",
      "ズーム",
      "LPR"
    ],
    "description": "車両出入口などでナンバー確認を行う用途を想定したPoE LPRカメラです。認識仕様・推奨距離は案件ごとに確認します。",
    "status": "standard"
  },
  {
    "id": "hs-lpr5m-001",
    "hsModel": "HS-LPR5M-001",
    "name": "5MP 10倍ズーム PoE LPRカメラ",
    "categoryLabel": "LPR",
    "type": "lpr",
    "resolution": "5MP",
    "resolutionKey": "5MP",
    "lens": "10× zoom",
    "lensType": "motorized",
    "image": "/images/security-camera/products/hs-lpr5m-001.png",
    "features": [
      "lpr"
    ],
    "locations": [
      "parking"
    ],
    "tags": [
      "5MP",
      "PoE",
      "ズーム",
      "LPR"
    ],
    "description": "車両出入口などでナンバー確認を行う用途を想定したPoE LPRカメラです。認識仕様・推奨距離は案件ごとに確認します。",
    "status": "standard"
  },
  {
    "id": "hs-nvr-04p-001",
    "hsModel": "HS-NVR-04P-001",
    "name": "4CH 最大12MP対応 PoE NVR録画機",
    "categoryLabel": "NVR",
    "type": "nvr",
    "resolution": "最大12MP入力",
    "resolutionKey": "nvr",
    "lens": "—",
    "lensType": "none",
    "image": "/images/security-camera/products/hs-nvr-04p-001.png",
    "features": [
      "nvr"
    ],
    "locations": [
      "shop",
      "office",
      "parking",
      "warehouse"
    ],
    "tags": [
      "4CH",
      "最大12MP入力",
      "PoE NVR"
    ],
    "description": "4CH構成に対応するPoE NVR録画機です。HDD構成・保存日数はカメラ台数と録画条件に合わせて選定します。",
    "status": "standard"
  },
  {
    "id": "hs-nvr-08p-001",
    "hsModel": "HS-NVR-08P-001",
    "name": "8CH 最大12MP対応 PoE NVR録画機",
    "categoryLabel": "NVR",
    "type": "nvr",
    "resolution": "最大12MP入力",
    "resolutionKey": "nvr",
    "lens": "—",
    "lensType": "none",
    "image": "/images/security-camera/products/hs-nvr-08p-001.png",
    "features": [
      "nvr"
    ],
    "locations": [
      "shop",
      "office",
      "parking",
      "warehouse"
    ],
    "tags": [
      "8CH",
      "最大12MP入力",
      "PoE NVR"
    ],
    "description": "8CH構成に対応するPoE NVR録画機です。HDD構成・保存日数はカメラ台数と録画条件に合わせて選定します。",
    "status": "standard"
  },
  {
    "id": "hs-nvr-16p-001",
    "hsModel": "HS-NVR-16P-001",
    "name": "16CH 最大12MP対応 PoE NVR録画機",
    "categoryLabel": "NVR",
    "type": "nvr",
    "resolution": "最大12MP入力",
    "resolutionKey": "nvr",
    "lens": "—",
    "lensType": "none",
    "image": "/images/security-camera/products/hs-nvr-16p-001.png",
    "features": [
      "nvr"
    ],
    "locations": [
      "shop",
      "office",
      "parking",
      "warehouse"
    ],
    "tags": [
      "16CH",
      "最大12MP入力",
      "PoE NVR"
    ],
    "description": "16CH構成に対応するPoE NVR録画機です。HDD構成・保存日数はカメラ台数と録画条件に合わせて選定します。",
    "status": "standard"
  }
];

const TYPE_FILTERS = [
  { key: 'all', label: 'すべて', Icon: Filter },
  { key: 'dome', label: 'ドーム', Icon: CircleDot, param: ['type', 'dome'] },
  { key: 'bullet', label: 'バレット', Icon: Camera, param: ['type', 'bullet'] },
  { key: 'night', label: 'IR夜間対応', Icon: Moon, param: ['type', 'night'] },
  { key: 'ptz', label: 'PTZ', Icon: Move3d, param: ['type', 'ptz'] },
  { key: 'panoramic', label: '180°パノラマ', Icon: PanelsTopLeft, param: ['type', 'panoramic'] },
  { key: 'lpr', label: 'LPR', Icon: ScanEye, param: ['type', 'lpr'] },
  { key: 'nvr', label: 'NVR', Icon: HardDrive, param: ['type', 'nvr'] },
];

const RESOLUTION_FILTERS = [
  { key: '2MP', label: '2MP' },
  { key: '4MP', label: '4MP' },
  { key: '5MP', label: '5MP' },
  { key: '8MP', label: '8MP / 4K' },
];

const LENS_FILTERS = [
  { key: 'fixed', label: '固定焦点' },
  { key: 'motorized', label: '電動ズーム / PTZ' },
];

const LOCATION_LABELS = {
  shop: '店舗・飲食店',
  office: 'オフィス・事務所',
  parking: '駐車場・建物外周',
  warehouse: '倉庫・工場',
};

const SecurityCameraLineup = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    const previousTitle = document.title;
    const description =
      '株式会社エイチエスの防犯カメラ・NVRラインアップ。ドーム、バレット、IR夜間対応、PTZ、180°パノラマ、LPR、NVRまで幅広くご案内します。';

    let metaDescription = document.querySelector('meta[name="description"]');
    const previousDescription = metaDescription?.getAttribute('content') ?? null;
    const createdMetaDescription = !metaDescription;

    document.title = '防犯カメラ ラインアップ｜株式会社エイチエス';

    if (!metaDescription) {
      metaDescription = document.createElement('meta');
      metaDescription.setAttribute('name', 'description');
      document.head.appendChild(metaDescription);
    }

    metaDescription.setAttribute('content', description);

    return () => {
      document.title = previousTitle;

      if (createdMetaDescription) {
        metaDescription.remove();
      } else if (previousDescription !== null) {
        metaDescription.setAttribute('content', previousDescription);
      }
    };
  }, []);

  const activeType = searchParams.get('type');
  const activeResolution = searchParams.get('resolution');
  const activeLens = searchParams.get('lens');
  const activeFeature = searchParams.get('feature');
  const activeLocation = searchParams.get('location');

  const filteredProducts = useMemo(() => {
    return PRODUCTS.filter((product) => {
      if (activeType && product.type !== activeType) return false;
      if (activeResolution && product.resolutionKey !== activeResolution) return false;
      if (activeLens && product.lensType !== activeLens) return false;
      if (activeFeature && !product.features.includes(activeFeature)) return false;
      if (activeLocation && !product.locations.includes(activeLocation)) return false;
      return true;
    });
  }, [activeType, activeResolution, activeLens, activeFeature, activeLocation]);

  const applySingleFilter = (name, value) => {
    const next = new URLSearchParams(searchParams);

    if (!value) next.delete(name);
    else next.set(name, value);

    setSearchParams(next);
  };

  const applyTypeFilter = (filter) => {
    const next = new URLSearchParams(searchParams);
    next.delete('type');

    // Keep compatibility with the Security Camera TOP "夜間対応" card.
    if (filter.key === 'night') {
      next.delete('feature');
      next.set('type', 'night');
    } else {
      next.delete('feature');
      if (filter.param) next.set(filter.param[0], filter.param[1]);
    }

    setSearchParams(next);
  };

  const clearAllFilters = () => {
    setSearchParams({});
  };

  const typeIsActive = (key) => {
    if (key === 'all') {
      return !activeType && !activeFeature;
    }
    return activeType === key;
  };

  return (
    <main className="scl-page" id="page-top">
      <section className="scl-hero">
        <div className="scl-container">
          <Link to="/products/security-camera" className="scl-back-link">
            <ArrowLeft size={14} strokeWidth={1.7} aria-hidden="true" />
            防犯カメラTOPへ戻る
          </Link>

          <div className="scl-hero-copy">
            <p className="scl-eyebrow">SECURITY CAMERA LINEUP</p>
            <h1>防犯カメラ ラインアップ</h1>
            <span className="scl-title-rule" aria-hidden="true" />
            <p>
              標準ドーム・バレットから、夜間対応、PTZ、180°パノラマ、LPR、NVRまで。
              設置場所や監視目的に合わせてお選びいただけます。
            </p>
          </div>
        </div>
      </section>

      <section className="scl-filter-section" aria-label="製品絞り込み">
        <div className="scl-container">
          <div className="scl-filter-head">
            <div>
              <p className="scl-section-kicker">FILTER</p>
              <h2>製品を絞り込む</h2>
            </div>

            {(activeType || activeResolution || activeLens || activeFeature || activeLocation) && (
              <button type="button" className="scl-reset" onClick={clearAllFilters}>
                <RotateCcw size={14} strokeWidth={1.8} aria-hidden="true" />
                絞り込みを解除
              </button>
            )}
          </div>

          <div className="scl-filter-groups">
            <div className="scl-filter-group">
              <div className="scl-filter-group-title">
                <SlidersHorizontal size={15} strokeWidth={1.7} />
                製品タイプ
              </div>
              <div className="scl-filter-list">
                {TYPE_FILTERS.map((filter) => (
                  <button
                    key={filter.key}
                    type="button"
                    className={`scl-filter-button ${typeIsActive(filter.key) ? 'is-active' : ''}`}
                    onClick={() => applyTypeFilter(filter)}
                    aria-pressed={typeIsActive(filter.key)}
                  >
                    <filter.Icon size={16} strokeWidth={1.7} aria-hidden="true" />
                    {filter.label}
                  </button>
                ))}
              </div>
            </div>

            <div className="scl-filter-group">
              <div className="scl-filter-group-title">解像度</div>
              <div className="scl-filter-list">
                {RESOLUTION_FILTERS.map((filter) => (
                  <button
                    key={filter.key}
                    type="button"
                    className={`scl-filter-button ${activeResolution === filter.key ? 'is-active' : ''}`}
                    onClick={() =>
                      applySingleFilter(
                        'resolution',
                        activeResolution === filter.key ? null : filter.key,
                      )
                    }
                    aria-pressed={activeResolution === filter.key}
                  >
                    {filter.label}
                  </button>
                ))}
              </div>
            </div>

            <div className="scl-filter-group">
              <div className="scl-filter-group-title">レンズ</div>
              <div className="scl-filter-list">
                {LENS_FILTERS.map((filter) => (
                  <button
                    key={filter.key}
                    type="button"
                    className={`scl-filter-button ${activeLens === filter.key ? 'is-active' : ''}`}
                    onClick={() =>
                      applySingleFilter(
                        'lens',
                        activeLens === filter.key ? null : filter.key,
                      )
                    }
                    aria-pressed={activeLens === filter.key}
                  >
                    {filter.label}
                  </button>
                ))}
              </div>
            </div>
          </div>

          {activeLocation && LOCATION_LABELS[activeLocation] && (
            <div className="scl-location-filter">
              <span>設置場所</span>
              <strong>{LOCATION_LABELS[activeLocation]}</strong>
            </div>
          )}
        </div>
      </section>

      <section className="scl-products-section">
        <div className="scl-container">
          <div className="scl-results-head">
            <div>
              <p className="scl-section-kicker">PRODUCTS</p>
              <h2>取扱製品</h2>
            </div>
            <p className="scl-result-count">
              <strong>{filteredProducts.length}</strong> / 30 製品
            </p>
          </div>

          {filteredProducts.length > 0 ? (
            <div className="scl-product-grid">
              {filteredProducts.map((product) => (
                <article className="scl-product-card" key={product.id}>
                  <div className="scl-product-image">
                    <img
                      src={product.image}
                      alt={product.name}
                      loading="lazy"
                    />
                  </div>

                  <div className="scl-product-body">
                    <div className="scl-product-topline">
                      <span className="scl-product-category">
                        {product.categoryLabel}
                      </span>
                      <span className="scl-product-model">
                        {product.hsModel}
                      </span>
                    </div>

                    <h3>{product.name}</h3>
                    <p className="scl-product-description">
                      {product.description}
                    </p>

                    <dl className="scl-mini-specs">
                      <div>
                        <dt>解像度</dt>
                        <dd>{product.resolution}</dd>
                      </div>
                      <div>
                        <dt>レンズ</dt>
                        <dd>{product.lens}</dd>
                      </div>
                    </dl>

                    <ul className="scl-tag-list" aria-label="主な特長">
                      {product.tags.map((tag) => (
                        <li key={tag}>{tag}</li>
                      ))}
                    </ul>

                    {product.status === 'tbc' && (
                      <p className="scl-tbc-note">
                        ※ 詳細仕様は現在確認中です。
                      </p>
                    )}

                    <Link
                      to={`/contact?subject=${encodeURIComponent(
                        `${product.hsModel} ${product.name}`,
                      )}`}
                      className="scl-product-link"
                    >
                      この製品について問い合わせる
                      <ArrowRight size={15} strokeWidth={1.7} aria-hidden="true" />
                    </Link>
                  </div>
                </article>
              ))}
            </div>
          ) : (
            <div className="scl-empty">
              <p>現在の条件に一致する製品がありません。</p>
              <button type="button" onClick={clearAllFilters}>
                絞り込みを解除する
              </button>
            </div>
          )}
        </div>
      </section>

      <section className="scl-contact">
        <div className="scl-container scl-contact-inner">
          <div>
            <p className="scl-contact-kicker">SELECTION SUPPORT</p>
            <h2>機種選定もご相談ください</h2>
            <p>
              設置場所、撮影範囲、必要な画質、夜間環境、録画日数などを確認しながら、
              用途に合ったカメラ・NVR構成をご案内します。
            </p>
          </div>

          <Link to="/contact" className="scl-contact-link">
            防犯カメラについて相談する
            <ArrowRight size={16} strokeWidth={1.7} aria-hidden="true" />
          </Link>
        </div>
      </section>
    </main>
  );
};

export default SecurityCameraLineup;
